(() => {
  const normalize = (value) => (value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();

  const escapeHtml = (value) => {
    const node = document.createElement("div");
    node.textContent = value || "";
    return node.innerHTML;
  };

  const cardHtml = (pokemon) => {
    const number = `#${String(pokemon.n).padStart(4, "0")}`;
    const countText = `${pokemon.count} produit${pokemon.count === 1 ? "" : "s"}`;

    const image = pokemon.img
      ? `<img class="pokedex-card__image" src="${escapeHtml(pokemon.img)}" alt="${escapeHtml(pokemon.alt || pokemon.name)}" width="184" height="184" loading="lazy" decoding="async">`
      : `<span class="pokedex-card__placeholder" aria-hidden="true">${escapeHtml((pokemon.name || "?").charAt(0).toUpperCase())}</span>`;

    return `<article class="pokedex-card">
      <a class="pokedex-card__link" href="/collections/${encodeURIComponent(pokemon.handle)}" aria-label="Voir tous les produits ${escapeHtml(pokemon.name)}">
        <span class="pokedex-card__number">${number}</span>
        <span class="pokedex-card__image-wrap">${image}</span>
        <span class="pokedex-card__name">${escapeHtml(pokemon.name)}</span>
        <span class="pokedex-card__count">${countText}</span>
      </a>
    </article>`;
  };

  const initialize = (root) => {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const data = Array.isArray(window.MissingNoPokedexData) ? window.MissingNoPokedexData.slice() : [];
    const grid = root.querySelector("[data-pokedex-grid]");
    const search = root.querySelector("[data-pokedex-search]");
    const sort = root.querySelector("[data-pokedex-sort]");
    const onlyProducts = root.querySelector("[data-pokedex-only-products]");
    const buttons = Array.from(root.querySelectorAll("[data-pokedex-letter]"));
    const shown = root.querySelector("[data-pokedex-shown]");
    const total = root.querySelector("[data-pokedex-total]");
    const stat = root.querySelector("[data-pokedex-stat]");
    const empty = root.querySelector("[data-pokedex-empty]");
    const error = root.querySelector("[data-pokedex-error]");
    const more = root.querySelector("[data-pokedex-load-more]");
    const pageSize = Number(root.dataset.pageSize) || 60;

    let activeLetter = "ALL";
    let limit = pageSize;

    if (!data.length) {
      error.hidden = false;
      more.hidden = true;
      return;
    }

    stat.textContent = String(data.length);

    const compare = (a, b, mode) => {
      if (mode === "name-asc") return a.name.localeCompare(b.name, "fr", { sensitivity: "base" });
      if (mode === "name-desc") return b.name.localeCompare(a.name, "fr", { sensitivity: "base" });
      if (mode === "products-desc") return b.count - a.count || a.n - b.n;
      if (mode === "products-asc") return a.count - b.count || a.n - b.n;
      return a.n - b.n;
    };

    const render = (reset = false) => {
      if (reset) limit = pageSize;

      const query = normalize(search.value);
      const filtered = data
        .filter((pokemon) => {
          const matchesSearch = !query || normalize(pokemon.search).includes(query);
          const matchesLetter = activeLetter === "ALL" || pokemon.letter === activeLetter;
          const matchesAvailability = !onlyProducts.checked || pokemon.count > 0;
          return matchesSearch && matchesLetter && matchesAvailability;
        })
        .sort((a, b) => compare(a, b, sort.value));

      const visible = filtered.slice(0, limit);
      grid.innerHTML = visible.map(cardHtml).join("");
      shown.textContent = String(visible.length);
      total.textContent = String(filtered.length);
      empty.hidden = filtered.length !== 0;

      const remaining = Math.max(filtered.length - visible.length, 0);
      more.hidden = remaining === 0;
      more.textContent = `Afficher plus (${remaining} restants)`;
    };

    search.addEventListener("input", () => render(true));
    sort.addEventListener("change", () => render(true));
    onlyProducts.addEventListener("change", () => render(true));

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        activeLetter = button.dataset.pokedexLetter || "ALL";
        buttons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-pressed", String(isActive));
        });
        render(true);
      });
    });

    more.addEventListener("click", () => {
      limit += pageSize;
      render(false);
    });

    render(true);
  };

  const initializeAll = () => {
    document.querySelectorAll("[data-pokedex-root]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", initializeAll);
})();
